import React from "react";
import axios from "axios";
import UserService from "./UserService";
import { postUserLog } from "./ConfigServices";

const postPageVisit = async (page) => {
    await axios
        .post(
            postUserLog('page visit', page),
            {
            },
            {
                headers: {
                    Authorization: `Bearer ${UserService.getToken()}`,
                    "Content-Type": "application/json; charset=utf-8",
                },
            }
        )
        .then((response) => {
        })
        .catch((error) => {
        });
};

export default postPageVisit;
